
import cookies from 'js-cookie'
import { login, getUserInfo, logout } from '@/api/user'
import { resetRouter } from '@/router'
import localStorage from 'localStorage'


const user = {}

user.state = {
  token: cookies.get('token'),
  name: '',
  role: ''
}

user.mutations = {
  set_token: (state, token) => {
    state.token = token
  },
  set_name: (state, name) => {
    state.name = name
  },
  set_role: (state, role) => {
    state.role = role
  }
}

user.actions = {
  login: ({ commit }, userInfo) => {
    const { userName, userPw } = userInfo

    return new Promise((resolve, reject) => {
      login({
        userName: userName.trim(),
        userPw
      }).then(response => {
        // response is a standed Promise object
        const { data } = response
        window.console.log(data)

        if (data.code=='1') {
          const body = data
          commit('set_token', body.token_uuid)
          cookies.set('token', body.token_uuid)
          //用户role 测试用  role 暂时 admin
          let user_role=''
          if (body.user_jiaose=='管理员')
          {
            user_role='admin'
          }
          else if (body.user_jiaose=='上传员')
          {
            user_role='upload'
          }
          else if (body.user_jiaose=='学校管理员')
          {
            user_role='schoolman'
          }
          else
          {
            //user_role='user'
            user_role='teacher'
          }
          localStorage.setItem('token',body.token_uuid);
          localStorage.setItem('name', body.user_name);
          localStorage.setItem('role', user_role);

          localStorage.setItem('user_yuming', body.user_yuming);
          localStorage.setItem('user_school', body.user_school);

		 // commit('set_name', 'admin')
		 // commit('set_role', 'admin')
		   window.console.log('ok'+body.user_jiaose)
       window.console.log(user_role)
        }

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getUserInfo: ({ commit, state }) => {
	   window.console.log('getUserInfo')
    return new Promise((resolve, reject) => {

      let user_token=localStorage.getItem('token');
      let user_name=localStorage.getItem('name');
      let user_role=localStorage.getItem('role');

      commit('set_name', user_name)
      commit('set_role', user_role)

      window.console.log('token'+user_token)
      window.console.log('name'+user_name)
      window.console.log('role'+user_role)

      user.data = {
        token: user_token,
        name: user_name,
        role: user_role
      }
      resolve(user.data)
      
  
    })
  },

  logout: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      logout({
        token: state.token
      }).then(reponse => {
        commit('set_token', '')
        commit('set_name', '')
        commit('set_role', '')
        resetRouter()
        cookies.set('token', '')
        resolve(reponse.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default user
